import { SearchResponseDto } from '@wwt/entities/api/search-response'
import { Offer, OfferWithoutPrice } from '@wwt/entities/search-response'

import { OfferPrice } from '@/entities/offerPrice'

import { getHotelDynamic } from './getHotelDynamic.ts'
import { getHotelStatic } from './getHotelStatic.ts'
import { getRoomDynamic } from './getRoomDynamic.ts'
import { getRoomStatic } from './getRoomStatic.ts'

export const extractOfferFromSearchResponse = (
	responseContent: SearchResponseDto['content'] | null,
	offerId: string | null
): Offer | null => {
	if (!responseContent) {
		return null
	}
	const offerKeys = responseContent.offers.find(
		offer => offer.nonPersistingOfferId === offerId
	)

	if (!offerKeys) {
		return null
	}

	const {
		integrationHotelId,
		integrationName,
		integrationRoomId,
		nonPersistingOfferId
	} = offerKeys

	const hotelStaticBase =
		responseContent.hotelStatic[integrationName][integrationHotelId]
	const hotelDynamicBase =
		responseContent.hotelDynamic[integrationName][integrationHotelId][
			nonPersistingOfferId
		]
	const roomStaticBase =
		responseContent.roomStatic[integrationName][integrationHotelId][
			integrationRoomId
		]
	const roomDynamicBase =
		responseContent.roomDynamic[integrationName][integrationHotelId][
			integrationRoomId
		][nonPersistingOfferId]

	const hotelStatic = getHotelStatic(hotelStaticBase)
	const hotelDynamic = getHotelDynamic(hotelDynamicBase)
	const roomStatic = getRoomStatic(roomStaticBase)
	const roomDynamic = getRoomDynamic(roomDynamicBase)

	const offerWithoutPrice: OfferWithoutPrice = {
		hotelStatic,
		hotelDynamic,
		roomStatic,
		roomDynamic,
		IDs: offerKeys
	}

	const price: OfferPrice = Object.create(OfferPrice).init(offerWithoutPrice)

	return {
		...offerWithoutPrice,
		price: price
	}
}
